// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicyPage_root__Yn6zx"};